import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as boosterActions from '../actions/booster.action';
import {LoadBoosterBenchmark} from '../actions/booster.action';
import {first, map, switchMap} from 'rxjs/operators';
import {Store} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {BoosterService} from "../../websites/website/booster/services/booster.service";
import {DbResponse} from "../../shared/interceptors/db-response";
import {BoosterBenchmark} from "../../websites/website/booster/back-end/benchmark/models/booster-benchmark.model";

@Injectable()
export class BoosterEffect {

  loadBoosterBenchmarkData = createEffect(() => this._actions$.pipe(
    ofType(boosterActions.LOAD_BOOSTER_BENCHMARK),
    switchMap((action: LoadBoosterBenchmark) => {
      return this._boosterService.getBenchmarkData(action.payload.websiteId)
        .pipe(
          first(response => !!response),
          map((response: DbResponse) => {
            if (response.success && response.data.system && response.data.system.total) {
              const benchmark = new BoosterBenchmark(response.data);
              return new boosterActions.LoadBoosterBenchmarkSuccess({
                websiteId: action.payload.websiteId,
                benchmark: benchmark
              });
            }
            return new boosterActions.LoadBoosterBenchmarkFail({websiteId: action.payload.websiteId});
          })
        );
    })
  ));

  constructor(
    private _store: Store<DbStoreState>,
    private _actions$: Actions,
    private _boosterService: BoosterService,
  ) {
  }
}
